import { StatRow } from 'oas';
import { GROUP_BY_OPTIONS } from '../constants';

export const getMultiplier = (stat: StatRow, groupBy: string) => {
    switch (groupBy) {
        case GROUP_BY_OPTIONS.activity:
            return stat['activity_array']?.length || 1;
        case GROUP_BY_OPTIONS.period:
            return stat['period_array']?.length || 1;

        // Time, distance and total are handled already in backend
        case GROUP_BY_OPTIONS.time:
        case GROUP_BY_OPTIONS.distance:
        case GROUP_BY_OPTIONS.total:
        default:
            return 1;
    }
};
